

import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { ConfirmationService, MessageService } from "primeng/api";


  import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";


  import { Subject } from "rxjs";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { NotaPratica } from "src/app/models/pratica.nota.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Utente } from "src/app/models/utente.model";
import { PraticheService } from "src/app/services/pratiche.service";


@Component({
    selector: "component-crea-nota",
    templateUrl: './crea-nota-pratica.component.html',
    styleUrls: ["../shared.component.css"],
  })
  export class CreaNotaPraticaComponent implements OnInit {

    protected _onDestroy = new Subject<void>();

    protected pratica: PraticaFlowdy2_Firestore;
    protected creaNotaForm: FormGroup;

    protected ref: DynamicDialogRef;
    isLoadingResults = false;

    constructor(
        private logger: NGXLogger,
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public confirmationService:ConfirmationService,
        public dialogService: DialogService,
        private formBuilder: FormBuilder,
        private praticheService:PraticheService,
        private messageService: MessageService,
      ) {
      this.pratica    = this.config.data.pratica;
      this.creaNotaForm = this.formBuilder.group({
        contenuto:             [ null, [Validators.required]]
      });
    }

   
    ngOnInit(): void {



    }
   

    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        let nuovaNota:NotaPratica = new NotaPratica();
            nuovaNota.contenuto =  this.creaNotaForm.get('contenuto').value;
            let utente:Utente = new Utente();
            utente.id = Number(localStorage.getItem("idUtente"));
            nuovaNota.utente = utente;
            this.logger.info(nuovaNota);
            this.praticheService.creaNota(this.pratica.id, nuovaNota).subscribe( {
              next: (res) => {
                
                this.dialogRef.close({ success: true});
              },  error: (e) => {
                this.messageService.add({
                  severity: "info",
                  summary: "Errore" , life:10000,
                    detail: "Errore in fase di creazione di una nota per la pratica!",
                  });
                this.dialogRef.close({ success: false });
              },
              complete: () => {
    
              }
            });
      }
    }
    
  }
